import React, { useEffect, useState, useCallback } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate, useParams } from "react-router-dom";
import { auth, rateItem, db } from "../firebase";
import { query, collection, getDocs, where, doc, getDoc } from "firebase/firestore";
import Header from "../components/Header";
//import Footer from "../components/Footer";

const handleRating = (rate,movie,uid,userdocname) => {
/*   console.log(rate);
  console.log(movie);
  console.log(uid); */
  rateItem(rate,movie,uid,userdocname);
}

const enlightElements = (e,flag,r) => {
  if (flag) {
    e.target.style.background = '#E2D34A';
    for (var i = 1; i < r; i++) {
      document.getElementById("dot_"+i).style.background = '#E2D34A';
    }
  } else {
    e.target.style.background = '#9294a3';
    for (var n = 1; n < r; n++) {
      document.getElementById("dot_"+n).style.background = '#9294a3';
    }
  }
}

function Rate() {
  const { id } = useParams();
  const [user, loading, error] = useAuthState(auth);
  const [title, setTitle] = useState("");
  const [originalTitle, setOriginalTitle] = useState("");
  const [year, setYear] = useState("");
  const [poster, setPoster] = useState("");
  const [rating, setRating] = useState(0);
  const [userdocname, setUserdocname] = useState("");
  const [counter, setCounter] = useState("");
  const [credits, setCredits] = useState("");
  const navigate = useNavigate();
  //const thumbPath1 = "https://www.themoviedb.org/t/p/w94_and_h141_bestv2/";
  const thumbPath2 = "https://www.themoviedb.org/t/p/w188_and_h282_bestv2/";

  const fetchUserName =  useCallback( async () => {
    try {
      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const doc = await getDocs(q);
      const data = doc.docs[0].data();
      const documentName = doc.docs[0].id;
      setUserdocname(documentName);
      setCounter(data.ratingCounter);
      setCredits(data.credits);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  }, [user]);

  const fetchData =  useCallback( async () => {
    try {
      let url =`https://api.themoviedb.org/3/movie/${id}?api_key=b26b68451b6e675fbb577afdb898aef1&language=en-US`;
      await fetch(url)
      .then((response) => response.json())
      .then((data) => {
        //console.log(data);
        setTitle(data.title);
        setOriginalTitle(data.original_title);
        setYear(data.release_date.substring(0,4));
        setPoster(data.poster_path);
        
      });
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  }, [id]);
  // }, [title, originalTitle, year, poster, id]); 

  const fetchRating = useCallback( async() => {
    try {
      const docName = `${user?.uid}.${id}`;
      const docRef = doc(db, "ratings", docName);
      /* const docSnap = await getDoc(docRef)
      .then((docSnap) => {
        console.log(docSnap.data());
        setRating(docSnap.data().rating);
      }); */
      const docSnap = await getDoc(docRef);
      //console.log("Document:", docName);
      //console.log("Rating:", docSnap.data()?.rating);
      //console.log("User docname:", userdocname);
      setRating(docSnap.data()?.rating);
      /* if (docSnap.exists()) {
        console.log("Rating:", docSnap.data().rating);
        setRating(docSnap.data().rating);
      } else {
        console.log("Not rated yet.");
      } */
    }
    catch (err) {
      console.error(err);
      console.log("An error occured while fetching user data");
    }
  }, [rating, id, user]);


  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/");
    console.log("ratingCounter",counter);
    console.log("credits",credits);
    if(counter > credits) {
      return navigate("/profile");
    }
    
    fetchUserName();
    fetchData();
    fetchRating();

  }, [user, loading, error, navigate, fetchUserName, fetchData, fetchRating]);
  
  const movie = {
    title: title,
    original_title: originalTitle,
    type: "movie",
    year: parseInt(year),
    poster_path: poster,
    tmdb_id: id
  }
  return (
    <>
    {loading === false ? (
    <div className="mb-0 px-3 main_screen">

      <Header key="1"  user={user} />

      <h2 className="p-2 text-center">Rate movie</h2>

      <div className="p-2 mt-0 text-center">
        <div className="rating_title">{title} </div>
        <div className="rating_original_title">{originalTitle !== title ? originalTitle : ""}</div>
        <div className="rating_year">{year}</div>
        <div className="rating_poster mt-3 mb-5">
          <img loading="lazy" className="poster" src={thumbPath2+poster} alt={title} />  
        </div>
        <div className="dots dots_large">
          <Dot value="1" key="1" movie={movie} uid={user?.uid} fill={rating > 0 ? 1 : 0} userdocname={userdocname}/>
          <Dot value="2" key="2" movie={movie} uid={user?.uid} fill={rating > 1 ? 1 : 0} userdocname={userdocname}/>
          <Dot value="3" key="3" movie={movie} uid={user?.uid} fill={rating > 2 ? 1 : 0} userdocname={userdocname}/>
          <Dot value="4" key="4" movie={movie} uid={user?.uid} fill={rating > 3 ? 1 : 0} userdocname={userdocname}/>
          <Dot value="5" key="5" movie={movie} uid={user?.uid} fill={rating > 4 ? 1 : 0} userdocname={userdocname}/>
          {/* <span id="dot_1" className="none" onClick={() => handleRating(1)}>o</span>
          <span id="dot_2" className="none" onClick={() => handleRating(2)}>o</span>
          <span id="dot_3" className="none" 
                onClick={() => handleRating(3)} 
                onMouseEnter={(e) => enlightElements(e,true,3)}
                onMouseLeave={(e) => enlightElements(e,false,3)}>o</span>
          <span id="dot_4" className="none" onClick={() => handleRating(4)}>o</span>
          <span id="dot_5" className="none" onClick={() => handleRating(5)}>o</span> */}
        </div>
      </div>
      {/* <Footer key="footer" user={user} footertype="back_only"/> */}
    </div>
    ) : (
    <div className="loadingscreen">
      <div className="loading spinner-border text-warning"></div>
    </div>
    ) }
    </>
  );
}

const Dot = (props) => {
  let rate = props.value;
  let movie = props.movie;
  let uid = props.uid;
  let fill = props.fill;
  let userdocname = props.userdocname;
  return(
    <span id={"dot_"+rate} className={fill ? "" : "none"} 
                onClick={() => handleRating(rate,movie,uid,userdocname)} 
                onMouseEnter={(e) => enlightElements(e,true,rate)}
                onMouseLeave={(e) => enlightElements(e,false,rate)}>o</span>
  );
}

export default Rate;
